<template>
  <div></div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "AzSsoAuth",
  methods: {
    ...mapActions(["getSession"]),
  },
  async mounted() {
    let search = location.search.substring(1);
    let obj = JSON.parse(
      '{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
      function (key, value) {
        return key === "" ? value : decodeURIComponent(value);
      }
    );
    if (obj && obj.access_token) {
      this.$axios.defaults.headers.Authorization = null;
      const fd = new FormData();
      fd.append("token", obj.access_token);
      fd.append("refresh", obj.refresh);
      this.$axios({
        method: "POST",
        url: "/api/auth/sso-login",
        data: fd,
      })
        .then(async (response) => {
          const result = response.data;
          localStorage.setItem("token", result.access_token);
          localStorage.setItem("refresh", result.refresh);
          this.$axios.defaults.headers.Authorization =
            "Bearer " + result.access_token;
          if (await this.getSession()) {
            await this.$axios(`/api/analytics/send/`, {
              method: "POST",
              data: {
                brand_name: "",
                brand_id: "",
                content_date: "",
                content_id: "",
                content_name: "",
                content_type: "",
                nosology_name: "",
                content_parameter: "",
                event_type: "auth_success",
                url: this.$root.analyticData.url,
                event_parameter: "",
                page_block: "",
                page_name: "",
                page_type: "",
                nova_id: this.$root.analyticData.nova_id,
                session_id: this.$root.analyticData.session_id,
                user_id: this.$root.analyticData.user_id,
                browser: this.$root.analyticData.browser,
                device_type: this.$root.analyticData.device,
                dpl_id: this.$route.query.access || "",
                os: this.$root.analyticData.os,
                utm_campaign: this.$route.query.utm_campaign || "",
                utm_content: this.$route.query.utm_content || "",
                utm_medium: this.$route.query.utm_medium || "",
                utm_source: this.$route.query.utm_source || "",
                utm_term: this.$route.query.utm_term || "",
              },
            });

            if (obj.back_url) {
              let url;
              let route = this.$router.resolve(obj.back_url).resolved;
              if (route.name !== "404") {
                this.$router.push(route);
              } else {
                try {
                  url = new URL(obj.back_url);
                } catch {
                  url = new URL("https://" + obj.back_url);
                }
                window.open(url, "_self");
              }
            } else {
              this.$router.push({
                name: "MainPage",
              });
            }
          } else {
            this.$router.push({ name: "MainPage" });
          }
          return true;
        })
        .catch((error) => {
          return false;
        });
    } else {
      this.$router.push({ name: "MainPage" });
    }
  },
};
</script>

<style>
</style>